import { styled } from '@mui/material';
import { Grid } from '@mui/system';

const PREFIX = 'CapTableForm';

export const classes = {
  formHeader: `${PREFIX}-formHeader`,
  margin: `${PREFIX}-margin`,
  textField: `${PREFIX}-textField`,
};

export const StyledGrid = styled(Grid)({
  [`& .${classes.formHeader}`]: {
    paddingTop: '1rem',
    paddingBottom: '1rem',
  },
  [`& .${classes.margin}`]: {
    marginBottom: 20,
  },
  [`& .${classes.textField}`]: {
    width: '100%',
  },
});